/**
 * Notes:
 * 1. 请保留文本中的'|'分隔符，这在网站的部分文本中是必须的。
 * 2. 请尽量结合语境进行翻译，拒绝机翻。
 * 3. 请使用本简体中文作为基本去翻译，其他语言为基本翻译可能会出现歧义或模糊意义等情况。
 */
// import version from '@/core/version'

export const all = {//通用数据
    version: '4.0.0-alpha',
    loading: '正在拉取网页所需数据...'
}

export const navbar = {
    nav_index: '首页',
    nav_down: '下载',
    nav_state: '状态',
    nav_donate: '赞助',
    nav_about: '关于',
    nav_rank: '排行榜'
}

export const navigation = {
    tab_unemail: '邮箱未验证',
    tab_toLogin: '请登录',
    tab_logout: '退出登录',
    tab_dashborad: '仪表盘',
    tab_icloud: '同步服务',
    tab_skin: '我的皮肤',
    tab_account: '我的账户',
    tab_games: '我的游戏',
    tab_set_night: '夜间模式'
}

export const footer = {
    copy: '©{year} {strong} 版权所有。{miit}',
    beian: '湘ICP备17020692号-3',
    co: 'MAKjust 空想派',
    tra: '"Minecraft"以及"我的世界"为Mojang Studios的商标，Minecraft游戏本体版权归Mojang Studios所有。',//"Minecraft" is a trademark of Mojang Studios, and the Minecraft game itself is copyrighted by Mojang Studios.
    developer: '开发者',
    we: '我们',
    link: '友情链接',
}

export const index = {
    msg_welcome: '欢迎您来到MAKjust minecraft 服务器',
    msg_welcome_text: '这是一个纯净原版生存服务器，与原生一样的生存，并有玩家们搭建起来的村落、居住地。在这里，您只需要玩的开心，我们只针对外挂等违规行为，不会干扰游戏体验。',
    msg_welcome_actions: '我的仪表盘|即刻注册',
    msg_join: '加入MAKjust官方群',
    msg_join_text: '和玩家们共同交流，获得一手官方消息，并可以在群内与我们联系与反馈。',
    msg_join_actions: '点击加群',
    news_title: '新闻|来自MCBBS',
    news_down: '获取新闻失败。',
    news_stop: '由于MCBBS新闻API改版，暂时无法获取。',
    post_title: '公告',
    post_down: '获取公告失败。'
}

export const dl = {
    title: '下载中心',
    note: '在这里您可以下载到MAKjust客户端的最新版本，以及独立的游戏包、MOD、开发者SDK、插件Demo等。',
    version: '版本：',
    release: '发行说明',
    //官方客户端
    official_title: '官方启动器',
    official_new_note: '官方发布集成了MAKjusntID的完整启动客户端，快速，简单，轻量级。',
    official_new_rt: '无界面的基础客户端核心，可以通过"{iconList}" -> {iconGames}我的游戏 -> Nyan Online进行管理。',
    official_new_ux: '加入独立UI的客户端，可以在无网络环境下使用。',
    official_old_title: '发布中的旧版本',
    official_historyVer: '历史版本',
    //Third-party Luncher
    luncher_title: '启动器（第三方）',
    luncher_tip: '仅作推荐，排序不分先后',
    luncher_download_tip: '请自行甄别，我们对您下载和使用第三方启动器所造成的任何后果不负任何责任。',
    //java
    java_title: 'Java下载',
    java_note: '运行Minecraft时所必须的依赖程序，我们提供官方下载渠道，点击即可前往官网下载。',
    //模组
    mods_title: '模组(MOD)',
    //光影
    shadow_title: '光影',
    //Button
    btn_stayTuned: '敬请期待',
    btn_toDownload: '前往下载',
    btn_download: '免费下载',
    btn_online: '在线管理',
    btn_noDownload: '暂无下载渠道',
}

export const status = {
    title: 'MAKjust Status',
    note: '我们每隔 5 分钟会去检测各项服务是否正常运转，这些数据由检测点自动生成，本页面会每分钟自动更新一次数据。',
    gameServer: '游戏服务器',
    gameServer_status: '状态：',
    gameServer_live: '在线人数：',
    dataServer: '数据服务',
    dataServer_error: '获取监控状态失败，请尝试刷新页面。',
    dataServer_60day: '近60天平均在线率',
    dataServer_online: '在线',
    dataServer_offline: '离线',
}

export const about = {
    title: '关于',
    subtitle: '一个安静的Minecraft服务器',
    readme: 'MAKjust Minecraft服务器于2014年成立，当初为PE服务器。2015年由于各种稀奇古怪的原因停服一年后，在2016年6月开始重新策划并搭建PC端服务器，现在已经在磕磕碰碰咕咕咕中走过了|个年头，事到如今人也老了，想安静的开个小服，一个不关的养老服，顺便以服务器做一些准备开源的项目的实验服。我们版本更新一般随着官方而来，若可不换地图，一般为保留存档，实在没办法可以部分保留物品。',
    donate_title: '资瓷我们',
    donate_text: '十分感谢您能理解我们的不易。{br}我们正在维护一个{strong1}的{strong2}服务器，因此我们只接受{strong3}赞助。赞助所得的大部分（≥90%）将用于保证Minecraft服务器的稳定运行。少部分（≤10%）将用于补贴团队鸽子（开发者）们。{br}我们支持使用爱发电渠道进行赞助，请在赞助时备注您的邮箱或ID，以便我们进行统计。',
    donate_strong: '公益性|非盈利|无条件',
    donate_afdian: '爱发电',
    donate_wechat: '微信',
    donate_list: '赞助者名单',//Sponsors, Channels, Amount
    donate_tHead: '赞助者|渠道|金额',
    donate_loading: '正在获取赞助者名单...',
    donate_error: '获取赞助者名单时发生了一个错误。',
    donate_channels: '爱发电|微信|支付宝|QQ'

}